import { Close, Delete } from "@mui/icons-material";
import { Box, Grid, IconButton, Stack, Typography } from "@mui/material";
import React from "react";

function GalleryProfile({
  data = [],
  setGalleryImages,
  mainData = {},
  setDataProfile,
  columns = 4,
  sizesCol = { xs: 2, md: 1.3, lg: 1 },
  type = "any",
}) {
  const handlerDeleteImage = (url, name) => {
    const isLastAdded = data[data.length - 1]?.name === name;

    const newArray = data.filter((x) => x.name !== name);
    setGalleryImages(newArray);

    if (type === "create") {
      let tempData = mainData.gallery?.filter((x) => x.name !== name) || [];

      if (isLastAdded) {
        const lastAddedImages =
          mainData.lastAddedImages?.filter((x) => x !== name) || [];
        setDataProfile({
          ...mainData,
          gallery: tempData,
          lastAddedImages: lastAddedImages,
        });
      } else {
        setDataProfile({ ...mainData, gallery: tempData });
      }
    } else {
      const lastArray = mainData.gallery?.filter((x) => x.name !== name) || [];
      const tempEditData =
        mainData.gallery_edit?.filter((x) => x.name !== name) || [];

      if (isLastAdded) {
        const lastAddedImages =
          mainData.lastAddedImages?.filter((x) => x !== name) || [];
        setDataProfile({
          ...mainData,
          gallery: lastArray,
          gallery_edit: tempEditData,
          lastAddedImages: lastAddedImages,
        });
      } else {
        setDataProfile({
          ...mainData,
          gallery: lastArray,
          gallery_edit: tempEditData,
        });
      }
    }
  };

  return (
    <Stack overflow="hidden">
      <Grid container columns={columns} spacing={1} sx={{ px: "0 !important" }}>
        {(!data || data.length === 0) && (
          <Grid item xs={4} lg={4}>
            <Box py={4} textAlign="center">
              <Typography component="span" color="GrayText">
                Sin imágenes
              </Typography>
            </Box>
          </Grid>
        )}
        {(data || []).map((image, index) => {
          return (
            <Grid
              item
              key={index}
              xs={sizesCol.xs}
              md={sizesCol.md}
              lg={sizesCol.lg}
            >
              <Box>
                <Box
                  sx={{
                    height: {
                      xs: "150px",
                      md: "190px",
                    },
                    position: "relative",
                    "&:hover img": {
                      filter: "saturate(50%)",
                    },
                  }}
                >
                  <img
                    src={image.url}
                    alt={image.name}
                    style={{
                      transition: "filter .3s",
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      borderRadius: 5,
                    }}
                  />
                  <IconButton
                    sx={{ position: "absolute", zIndex: 20, right: 0, top: 0 }}
                    onClick={() => {
                      handlerDeleteImage(image.url, image.name);
                    }}
                  >
                    <Delete sx={{ color: "red" }} />
                  </IconButton>
                </Box>
                <Typography
                  fontSize="small"
                  textAlign="center"
                  sx={{ maxWidth: "100%", overflowX: "hidden" }}
                >
                  {image.name}
                </Typography>
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Stack>
  );
}

export default GalleryProfile;
